<template>
    <div class="contain">
        <van-popup
                v-model="isShow"
                position="bottom"
                :style="{ height: '70%' }"
                @click-overlay="onClonse"
                :close-on-click-overlay="false"
        >
            <div class="search-box">
                <van-search placeholder="请输入手机号/用户名称搜索" v-model="keywords" @input="onSearch"/>
            </div>
            <div class="user-box">
                <van-radio-group v-model="radio">
                    <van-cell-group>
                        <van-cell is-link
                                  v-for="(item, index) in businessUserList"
                                  :key="index"
                                  clickable
                                  @click="radio= item"
                                  v-if="index < limit"
                        >
                            <template slot="title">
                                <img :src="item.face"
                                     alt="" class="cell-img">
                                <div class="custom-title">{{item.name}}</div>
                                <div class="van-cell__label">{{item.phone}}</div>
                            </template>
                            <van-radio slot="right-icon" :name="item" checked-color="#FD2840"/>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </div>
            <div class="createbtn">
                <van-button type="danger" size="large" @click="UserAdd">确定</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Popup, Toast, Cell, CellGroup, Icon, Search, RadioGroup, Radio} from 'vant';

    Vue.use(Popup).use(Toast).use(Cell).use(CellGroup).use(Icon).use(Search).use(RadioGroup).use(Radio);

    export default {
        name: 'UserPicker',
        props: {
            show: {
                type: Boolean,
                default: false,
            },

            limit: {
                type: Number,
                default: 1,
            }
        },
        data() {
            return {
                isShow: false,
                result: [],
                keywords: '',
                businessUserList: [],
                radio: ''
            }
        },
        mounted() {
            this.getUserOption();
        },
        watch: {
            show(value) {
                this.isShow = value
            }
        },
        methods: {
            getUserOption() {
                this.onSearch()
            },

            onClonse() {
                this.$emit('onClonse');
            },

            onSearch() {
                let that = this;
                that.$api.get('/adminapi/user/userOptions', {'keywords': that.keywords}, (res) => {
                    that.businessUserList = res.data
                })
            },

            UserAdd() {
                let that = this;
                console.log(that.radio)

                that.$emit('onUserAdd', that.radio)
                that.isShow = false
            }

        }
    }
</script>

<style scoped>
    .van-search__content {
        background: #EFEFF4;
    }

    .user-box {
        margin-bottom: 50px;
    }

    .createbtn {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .cell-img {
        width: 48px;
        height: 48px;
        float: left;
        border-radius: 50%;
        margin-right: 15px;
    }
</style>



// WEBPACK FOOTER //
// UserPicker.vue?f35aa378